import { defineMessages } from "react-intl";
import "react";
import "@mui/material";
import "@mui/x-data-grid";
import "uuid";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../../components/alerts/Message.style.js";
import "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "../../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../../components/pagination/StyledPagination.js";
import "../../../components/data-grid/mui/GridColumnsButton.js";
import "../../../components/data-grid/mui/GridColumnsPanel.js";
import "../../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../../components/data-grid/mui/cells/InvalidDataCell.js";
import { DataGridEntityConfigFactory } from "../../../components/data-grid/mui/types.js";
import "../../../components/data-grid/mui/cells/CurrencyCell.js";
import "../../../components/data-grid/mui/cells/DateCell.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/tooltip/Tooltip.js";
import "moment-timezone";
import "../../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "../../../components/data-grid/mui/cells/LabelsCell.js";
import "../../../components/data-grid/mui/cells/NumberCell.js";
import { renderCellHeader } from "../../../components/data-grid/mui/cells/TextCell.js";
import "../../../components/link/LinkHOC.js";
import "../../../components/link/LinkButton.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../../components/data-grid/mui/cells/DurationCell.js";
import "../../../components/data-grid/mui/cells/PercentCell.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import "../../../components/data-grid/mui/cells/ButtonCell.js";
import { renderP2PTransferAmountEditableCell } from "./AmountCell.js";
import "./DataGrid.js";
import { renderP2PTransferDirectionEditableCell } from "./TypeCell.js";
const localized = defineMessages({
  transactionsGridP2PDirection: {
    id: "DataGridTransaction_P2PDirection",
    defaultMessage: "Direction"
  },
  transactionsGridTransferAmount: {
    id: "DataGridTransaction_TransferAmount",
    defaultMessage: "Transfer Amount"
  }
});
class DataGridTransactionEditableConfigFactory extends DataGridEntityConfigFactory {
  getColumnConfig() {
    const columnsMapping = {
      p2p_direction_editable: {
        field: "p2p_direction_editable",
        valueGetter: (_, row) => this.getType(row),
        renderHeader: () => renderCellHeader(localized.transactionsGridP2PDirection),
        renderCell: renderP2PTransferDirectionEditableCell,
        renderEditCell: renderP2PTransferDirectionEditableCell,
        flex: 0.15,
        editable: true,
        sortable: false
      },
      p2p_transfer_amount_editable: {
        field: "p2p_transfer_amount_editable",
        valueGetter: (_, row) => this.getP2PTransferAmount(row),
        renderHeader: () => renderCellHeader(localized.transactionsGridTransferAmount),
        renderCell: renderP2PTransferAmountEditableCell,
        renderEditCell: renderP2PTransferAmountEditableCell,
        flex: 0.15,
        editable: true,
        sortable: false
      }
    };
    return columnsMapping;
  }
  getType(model) {
    return model?.transaction_type;
  }
  getP2PTransferAmount(model) {
    const value = { amount: model?.amount, currency: this.getCurrency(model) };
    return value;
  }
  getCurrency(model) {
    return model?.currency;
  }
}
export {
  DataGridTransactionEditableConfigFactory
};
//# sourceMappingURL=DataGridEditable.js.map
